import { render, staticRenderFns } from "./Prologue.vue?vue&type=template&id=52503e95&scoped=true&"
import script from "./Prologue.vue?vue&type=script&lang=js&"
export * from "./Prologue.vue?vue&type=script&lang=js&"
import style0 from "./Prologue.vue?vue&type=style&index=0&id=52503e95&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52503e95",
  null
  
)

export default component.exports